var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-btn"}},[_c('v-btn',{attrs:{"id":"the-btn"},on:{"click":function($event){return _vm.goToForm()}}},[_c('v-icon',[_vm._v("chat_bubble_outline")]),_vm._v(" Contact me ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }